import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { io } from "socket.io-client";
import "./Video.css";

const Video = () => {
  const navigate = useNavigate();
  const [roomId, setRoomId] = useState("");
  const [copied, setCopied] = useState(false);

  const socketRef = useRef(null);

  // Initialize socket connection to your Render backend
  useEffect(() => {
    socketRef.current = io("https://whatsappbackend-sq5p.onrender.com", {
      transports: ["websocket", "polling"],
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, []);

  /* Generate a new room ID */
  const createRoom = () => {
    const id = uuidv4();
    setRoomId(id);
    setCopied(false);
  };

  /* Copy room link */
  const copyLink = () => {
    if (!roomId.trim()) {
      alert("Please generate a Room ID first");
      return;
    }
    const link = `${window.location.origin}/videoPage?roomId=${roomId}`;
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  /* Join room — navigate with state */
  const joinRoom = () => {
    if (!roomId.trim()) {
      alert("Please enter or generate a Room ID");
      return;
    }
    // Emit join event to backend (optional for signaling)
    socketRef.current.emit("joinRoom", roomId);

    navigate("/videoPage", { state: { roomId } });
  };

  return (
    <div className="videoContainer">
      <div className="videoBox">
        <h1 className="videoTitle">🎥 Video Call Room</h1>
        <p className="videoSubtitle">Create a new room or join an existing one</p>

        <div className="roomActions">
          <button className="videoBtn createBtn" onClick={createRoom}>
            ➕ Generate Room ID
          </button>

          <div className="joinSection">
            <input
              type="text"
              placeholder="Enter Room ID"
              className="roomInput"
              value={roomId}
              onChange={(e) => { setRoomId(e.target.value); setCopied(false); }}
            />
            <button className="videoBtn joinBtn" onClick={joinRoom}>
              🔗 Join Room
            </button>
          </div>

          {roomId.trim() && (
            <div className="shareLinkSection">
              <div className="shareLinkBox">
                <span className="shareLinkText">
                  {`${window.location.origin}/videoPage?roomId=${roomId.slice(0, 20)}…`}
                </span>
                <button className="copyBtn" onClick={copyLink}>
                  {copied ? "✅ Copied!" : "📋 Copy Link"}
                </button>
              </div>
              <p className="shareHint">
                Share this link — anyone who opens it will join your room
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Video;